/**
 * Filas de las matrices de configuración: las de la BD tienen Id numérico; las que se crean en pantalla y aún no
 * se guardan, uno temporal con prefijo. No se decide por la longitud del Id: con Ids de la BD de 4 o más dígitos
 * las filas existentes se tomaban por nuevas (se creaban en vez de editarse y no se borraban).
 */
const PREFIJO_FILA_NUEVA = 'nueva-';

export const idFilaNueva = () => PREFIJO_FILA_NUEVA + Math.random().toString(36).substring(2);

export const esFilaNueva = (id: string | number) => !/^\d+$/.test(String(id));
